"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicySummaryInfoDialog = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const SummaryWithCopyButton_1 = require("../../../components/SummaryWithCopyButton");
const FeatureContext_1 = require("../../../core/contexts/FeatureContext");
const request_1 = require("../../../core/request");
require("./types");
const PolicySummaryInfoDialog = ({ deactivate, policyId, getEmptyPolicy, getFieldValuesFromModel, getSummaryData, }) => {
    const { t, getProxy } = FeatureContext_1.useFeatureContext();
    const proxyRef = react_1.useRef(getProxy('getPolicy'));
    const [policyInfoResult, policyInfoActions] = request_1.useRequest({
        httpProxy: proxyRef.current,
    });
    const { data: policyData, meta: { loading: processing }, } = policyInfoResult;
    const summaryData = getSummaryData(getFieldValuesFromModel(policyData || getEmptyPolicy()));
    react_1.useEffect(() => {
        if (!policyId) {
            return;
        }
        policyInfoActions.load({
            params: { policyId },
        });
    }, [policyId]);
    return (react_1.default.createElement(components_1.Dialog, { header: t('policySummaryInfo|header'), size: {
            width: components_1.DIALOG_SIZE.m,
            height: components_1.DIALOG_SIZE.xl,
        }, actions: [
            {
                view: components_1.ACTION_VIEW.primary,
                text: t('policySummaryInfo|closeButton'),
                onClick: () => deactivate(),
            },
        ], onRequestClose: () => {
            deactivate();
        }, loading: processing },
        react_1.default.createElement("div", null, !processing && react_1.default.createElement(SummaryWithCopyButton_1.SummaryWithCopyButton, { summaryData: summaryData }))));
};
exports.PolicySummaryInfoDialog = PolicySummaryInfoDialog;
//# sourceMappingURL=PolicySummaryInfoDialog.js.map